import FAQ from "../../public/faq.json";
import { useLang, useT } from "@/i18n";

type Item = { q: string; a: string };
const BY_LANG = FAQ as unknown as Record<string, Item[]>;

/** Întrebările pe care le are orice cumpărător, cu răspuns.
 *
 *  Cele două care contează — cât costă și cât durează — nu aveau răspuns
 *  nicăieri pe site. Tăcerea la ele nu păstrează putere de negociere, doar mută
 *  vizitatorul pe un site care răspunde.
 *
 *  Construit pe <details>, nu pe stare React: se deschide cu tastatura, e
 *  anunțat corect de cititoarele de ecran, funcționează dacă JavaScript-ul cade
 *  și e găsibil cu Ctrl+F chiar închis, fiindcă textul e în DOM. Atributul `name`
 *  face acordeonul exclusiv fără nicio linie de cod: deschiderea uneia o închide
 *  pe cealaltă.
 *
 *  Două coloane, cu lista tăiată în două, nu o grilă care așază elementele pe
 *  rânduri: într-o grilă, deschiderea unei întrebări din stânga ar împinge în jos
 *  și întrebarea din dreapta, care n-are nicio legătură cu ea. Așa fiecare
 *  coloană curge independent.
 *
 *  Textul vine din public/faq.json, același fișier din care serverul scoate
 *  FAQPage JSON-LD pentru limba rutei — altfel Google ar vedea întrebări care nu
 *  sunt în pagină. */
function Item({ q, a, level }: Item & { level: 2 | 3 }) {
  // Întrebarea era un <span>: douăsprezece întrebări cu răspuns, invizibile ca
  // structură pentru un crawler. Nivelul diferă după context — pe landing FAQ-ul
  // are deja un h2 deasupra, deci întrebările stau la h3; pe /faq titlul paginii
  // e h1, deci ele urcă la h2. Un h2 sub alt h2 ar fi rupt ierarhia.
  const H = level === 2 ? "h2" : "h3";
  return (
    <details className="faqi" name="faq">
      <summary>
        <H className="faqq">{q}</H>
        {/* Plus care devine minus. Un chevron rotit e ornament; plus/minus spune
            ce se întâmplă la apăsare. */}
        <span className="faqm" aria-hidden="true" />
      </summary>
      <p>{a}</p>
    </details>
  );
}

export default function Faq({ showHead = true, limit }: { showHead?: boolean; limit?: number } = {}) {
  const level = showHead ? 3 : 2;
  const lang = useLang();
  const t = useT();
  const all = BY_LANG[lang] ?? BY_LANG.en;
  const items = limit ? all.slice(0, limit) : all;
  const half = Math.ceil(items.length / 2);
  const cols = [items.slice(0, half), items.slice(half)];

  return (
    <>
      {showHead && (
        <div className="sechead stepshead">
          <div className="eyebrow">{t.home.faqEyebrow}</div>
          <h2>{t.home.faqHead}</h2>
        </div>
      )}
      <div className="faq">
        {cols.map((col, i) => (
          <div className="faqcol" key={i}>
            {/* Cusătura de sudură: coloana e legată de pagină printr-un cordon,
                nu doar așezată lângă ea. */}
            <span className="seam" aria-hidden="true" />
            {col.map((it) => <Item key={it.q} {...it} level={level} />)}
          </div>
        ))}
      </div>
    </>
  );
}
